import { ScheduleMessageType } from "../models/conversations/schedule-messages.model";

export const trimMessage = (message: string, chars: number) => {
    let shortMessage = message.slice(0, chars);
    let index = (shortMessage.lastIndexOf("{{") || shortMessage.lastIndexOf("{") || shortMessage.lastIndexOf("{{_"))
    let indexPosition = (index === 0 || index === -1) ? 0 : index
    let patternFirst = (shortMessage.match(/{{_/g) || []).length
    let patternLast = (shortMessage.match(/_}}/g) || []).length
    let string = shortMessage.slice(0, indexPosition)
    let stringIndex = indexPosition === 0 ? shortMessage : string
    let finalString = patternFirst !== patternLast ? stringIndex : shortMessage;
    return !!message ? finalString + (message.length > chars ? "..." : "") : "";
}

export const findScheduleType = (type: string) => {
    switch (type) {
        case "One Time":
            return ScheduleMessageType.ONE_TIME;
        case "Daily":
            return ScheduleMessageType.DAILY;
        case "Weekly":
            return ScheduleMessageType.WEEKLY;
        default:
            return ScheduleMessageType.MONTHLY;
    }
}

